import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import OwnerDashboard from './OwnerDashboard'
import EmployeeDashboard from './EmployeeDashboard'

const DashboardPage = () => {
  const { isWorkspaceSwitched } = useAuth()

  return (
    <div className="space-y-6">
      {isWorkspaceSwitched ? (
        <EmployeeDashboard />
      ) : (
        <OwnerDashboard />
      )}
    </div>
  )
}

export default DashboardPage
